import { render, staticRenderFns } from "./PolicySelect.vue?vue&type=template&id=9b85e36e&"
import script from "./PolicySelect.vue?vue&type=script&lang=js&"
export * from "./PolicySelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports